import CheckBoxEmpty from '@lib/core/src/assets/buttons-icons/checkbox-empty.svg?react';
import CheckBoxSelected from '@lib/core/src/assets/buttons-icons/checkbox-selected.svg?react';
import { Box, Checkbox as MuiCheckbox, styled } from '@mui/material';

const Container = styled(MuiCheckbox)({
  position: 'absolute',
  zIndex: 2,
  top: '2px',
  left: '2px',
  padding: '0',
  '& .MuiSvgIcon-root': {
    backgroundColor: 'transparent',
    fontSize: '16px'
  }
});

const CheckBoxSelectedWrapper = styled(Box)({
  padding: '4px'
});

interface CheckboxProps {
  checked: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const Checkbox = ({ checked, onClick }: CheckboxProps) => (
  <Container
    icon={<CheckBoxEmpty />}
    checkedIcon={
      <CheckBoxSelectedWrapper>
        <CheckBoxSelected />
      </CheckBoxSelectedWrapper>
    }
    checked={checked}
    onClick={onClick}
  />
);

export default Checkbox;
